import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import ComponentHeader from '../commoncomponents/ComponentHeader';
import ScmBottomButtonsforWorkOrder from './ScmBottomButtonsforWorkOrder';
import {
  getAuthToken,
  getCreatedBy,
} from "../../utility/tokenUtility";
import { updateWorkOrderStatus } from '../../redux/actions/workOrderActionTypes';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import ScmSignatureGrid from './ScmSignatureGrid';
import ScmRepositry from "../../api/repositories/scmRepository";
import CustomTooltip from '../commoncomponents/CustomTooltip';
import { format, isValid, parseISO } from "date-fns";
import { processingPercentageValue, statusList } from '../../utility/message';


const ScmAttachments = ({ setPage, buttonAttributes, page }) => {

  //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
  const findHeaderContent = buttonAttributes.find(
    (item) => item.currentPageName === page
  );
  const createdBy = getCreatedBy("createdBy");
  const [rows, setRows] = useState([{
    id: 1,
    file: null,
    documenttitle: '',
    documenttype: '',
    filesize: '',
  }]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();
  const token = getAuthToken("id_token");
  const location = useLocation();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [dropDownValue, setDropDownValue] = useState("");
  const [dropdownError, setDropdownError] = useState(false);
  const [dropDownErrorMessage, setDropDownErrorMessage] = useState("");
  const [pageName, setPageName] = useState("Part Replacement");
  const [attachmentMandatory, setAttachmentMandatory] = useState(false);


  const assetCategoryType = useSelector((state) => state?.serviceType);
  const basicDetails = useSelector((state) => state.scmBasicDetails);
  const dispatch = useDispatch();
  const completionInfoData = basicDetails?.completionInfo || {};

  const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  const viewmode = location.state?.viewmode;
  const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
  const status = useSelector((state) => state?.workOrderStatus?.status);
  const statusMapping = {
    "Open": 1,
    "In Progress": 3,
    "Completed": 4,
    "Closed": 5,
    "Cancelled": 6
  };
  const attachmentTypeOptions = [
    { id: 1, label: "Before" },
    { id: 2, label: "After" },
    { id: 3, label: "Others" },
  ];

  // Map the current status to the corresponding number
  const mappedStatus = statusMapping[status] || null;

  function AddRowButton(props) {
    const handleClick = () => {
      props.onClick();
    };

    return (

      <Box sx={{ mb: 1 }}>

        <Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleClick} >
          Add Row
        </Button>
      </Box>
    );
  };  

  const fetchFiles = async () => {

    const checkFieldName = serviceType === "fem" ? "fem" : "bem";
    const checkFemorBem = serviceType === "fem" ? "Fem" : "Bem";
    let schWorkorderAttachments = [];
    try {
      const response = await axios.get(`${checkGraph}/api/ScheduledCorrectiveMaintenance/GetschcorrectiveattachmentList/${basicDetails?.id},1,1000`, config);
      const fetchedFiles = response.data;
      
      if(basicDetails?.referenceWorkOrderNo?.id){
        schWorkorderAttachments = await axios.get(`${checkGraph}/api/${checkFemorBem}unscheduledworkorder/GetscheduledAttachmentsList/${basicDetails?.workorderId},1,1000`, config);
      };

        const schAttachments = schWorkorderAttachments?.data?.map((file) => {
        const attachmentTypeId = file?.[`${checkFieldName}woattachmenttypeId`] || "";
        const attachmentTypeOption = attachmentTypeOptions.find(option => option?.id === attachmentTypeId);

          setDropDownValue(prev => ({
              ...prev,
              [file?.id]: attachmentTypeOption || { id: 3, label: "Others" },
          }));

          return {
              id: file?.id,
              filename: file?.filename,
              filepath: file?.filepath,
              filesize: file?.filesize,
              documenttitle: file?.documenttitle,
              documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
              attachmentType: attachmentTypeOption || { id: 3, label: "Others" },
          };
      });
      
      
      const gridRows = fetchedFiles.map((file) => {
        const attachmentTypeId = file?.[`${checkFieldName}woattachmenttypeId`] || "";
        const attachmentTypeOption = attachmentTypeOptions.find(option => option?.id === attachmentTypeId);


        setDropDownValue(prev => ({
          ...prev,
          [file?.id]: attachmentTypeOption || { id: 3, label: "Others" },
        }));

        return {
          id: file?.id,
          filename: file?.filename,
          filepath: file?.filepath,
          filesize: file?.filesize,
          documenttitle: file?.documenttitle,
          documenttype: file?.documenttitle?.split('.')?.pop()?.toLowerCase(),
          attachmentType: attachmentTypeOption || { id: "", label: "" },
        };
      });

      let mainRows = [...(gridRows || []), ...(schAttachments || [])];
      

      if (response?.data?.length > 0 || schAttachments?.length > 0) {
        setRows(mainRows);
      } else if (viewmode == true) {
        setRows(mainRows);
      }
      else {
        const newRow = {
          id: 1,
          documenttitle: '',
          file: '',
          documenttype: "",
          filesize: '',
          attachmenytType: { id: 3, label: "Others" }
        };
        setDropDownValue((prev) => ({
          ...prev,
          [newRow?.id]: { id: 3, label: "Others" }
        }));        
        setRows([newRow]);
      }
    } catch (error) {
      console.error('Error fetching files:', error);
    }


  };

  useEffect(() => {
    fetchFiles();

    if (basicDetails?.assessments?.partsRequired?.id === 1) {
      setPageName("Part Replacement");
    } else if (basicDetails?.assessments?.partsRequired?.id === 2) {
        setPageName("Completion Info");
    } else {
        setPageName("Part Replacement");
    }
  }, []);

  

  const handleDeleteClick = (id) => () => {
    const selectedRow = rows.find(row => row.id === id);
    if (rows.length === 1 && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
      return;
    }
    if (selectedRow && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
      const updatedRows = rows.filter((row) => row.id !== id);
      setRows(updatedRows);
      const updatedSelectedFiles = selectedFiles.filter(file => file.id !== id);
      setSelectedFiles(updatedSelectedFiles);
    } else if (selectedRow) {
      setSelectedId(id);
      setDeleteDialogOpen(true);
    }
  };

  const handleDeleteConfirm = async () => {
    const selectedRow = rows.find(row => row.id === selectedId);
    if (rows.length === 1 && (!selectedRow.documenttype || selectedRow.documenttype === '')) {
      setDeleteDialogOpen(false);
      return;
    }

    if (selectedRow) {
      try {
        if (typeof selectedId === 'string') {
          const response = await axios.delete(
            `${checkGraph}/api/${serviceType}schcorrectiveattachments/${selectedId}`,
            config
          );

          if (response.status >= 200 && response.status <= 204) {
            const updatedRows = rows.filter((row) => row.id !== selectedId);
            setRows(updatedRows);
            const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
            setSelectedFiles(updatedSelectedFiles);
            fetchFiles();
          } else {
            throw new Error('Failed to delete record');
          };
        } else if (typeof selectedId === 'number') {
          const updatedRows = rows.filter((row) => row.id !== selectedId);
          setRows(updatedRows);
          const updatedSelectedFiles = selectedFiles.filter(file => file.id !== selectedId);
          setSelectedFiles(updatedSelectedFiles);
          if (updatedRows.length < 1) {
            fetchFiles();
          };
        };
      } catch (error) {
        setError(true);
        setErrorMessage('Error deleting attachment. Please try again.');
      }
    }
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleAddRow = () => {
    const id =
      rows.length > 0
        ? Math.max(...rows.map((row) => (isNaN(row.id) ? 0 : Number(row.id)))) + 1
        : 1;
    const newRow = {
      id: id,
      file: "",
      documenttitle: '',
      documenttype: '',
      filesize: '',
      attachmenytType: { id: 3, label: "Others" }
    };
    setRows((oldRows) => [...oldRows, newRow]);
    setDropDownValue((prev) => ({
      ...prev,
      [id]: { id: 3, label: "Others" },
    }));

    setDropdownError((prev) => ({
      ...prev,
      [id]: false,
    }));

    setDropDownErrorMessage((prev) => ({
      ...prev,
      [id]: "",
    }));
  };

  const handleFileChange = (event, id) => {
    
    const file = event.target.files[0];
    if (!file) return;
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (file.size > 20 > 1024 > 1024) {
      setError(true);
      setErrorMessage('Error: File size exceeds 20 MB. Please select smaller files.');
      return;
    };

    // Get dropdown value for the row
    const dropdownValue = dropDownValue[id];
    const isAfterOrBefore = dropdownValue?.id === 1 || dropdownValue?.id === 2;
    const allowedFileExtensions = isAfterOrBefore ? ['jpeg', 'jpg', 'png'] : ['doc', 'jpeg', 'jpg', 'png', 'xlsx', 'csv', 'pdf', 'docx'];

    // Check file type validity
    if (!allowedFileExtensions.includes(fileExtension)) {
      setError(true);
      setErrorMessage(isAfterOrBefore
        ? 'Error: Only JPEG, JPG, and PNG files are allowed for this selection.'
        : 'Error: Only DOC, JPEG, JPG, PNG, XLSX, CSV, and PDF files are allowed.'
      );

      // Show attachment type dialog for invalid files on "after" or "before" selections
      if (isAfterOrBefore) {
        // setAttachmentTypeDialog(true);
        setDropDownValue(prev => ({
          ...prev,
          [id]: { id: 3, label: "Others" }, // Reset dropdown if invalid file is chosen
        }));
      }
      return;
    }

    let updatedSelectedFiles = [...selectedFiles];
    const fileIndex = updatedSelectedFiles.findIndex((file) => file.id === id);
    if (fileIndex > -1) {
      updatedSelectedFiles[fileIndex] = { id, file };
    } else {
      updatedSelectedFiles.push({ id, file });
    };
    setSelectedFiles(updatedSelectedFiles);

    const updatedRows = rows.map((row) => {
      if (row.id === id) {
        let fileSize;
        if (file.size >= 1024 * 1024) {
          fileSize = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
          fileSize = (file.size / 1024).toFixed(2) + ' KB';
        };

        return {
          ...row,
          file,
          documenttitle: fileName,
          documenttype: fileExtension,
          filesize: fileSize,
        };
      };
      return row;
    });

    setRows(updatedRows);
    setAttachmentMandatory(false);
  };

  const handleDownload = async (file) => {
    try {
      const response = await axios.get(`${MasterGraph}/api/FileUpload/DownloadFile/${file.filename}`, {
        ...config,
        responseType: 'blob'
      });

      if (response) {
        const url = URL.createObjectURL(response.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.documenttitle || file.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      else {
        if (file && file instanceof Blob) {
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = file.documenttitle || file.filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } else {
          console.error('Invalid file object:', file);
        };
      };
    } catch (error) {
      console.error('Error downloading file:', error);
    };
  };


  const handleDownloadClick = (event, file) => {
    event.preventDefault();
    handleDownload(file);
  };
  function uuidv4(extension) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    }) + '.' + extension;
  };

  const uploadFiles = async (formData) => {
    try {
      let storeFileNameArray = [];
      let storeregsitredFilesResponse = [];
      let storefileUploadResponse = [];
      for (let i = 0; i < selectedFiles?.length; i++) {
        const formData = new FormData();
        const extension = selectedFiles[i]?.file?.name.split('.').pop();
        const fileName = uuidv4(extension); // generate a unique id
        formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
        storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.file?.name}`, selectedFileId: selectedFiles[i]?.id });

        try {
          const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
          storeregsitredFilesResponse.push(fileUploadResponse.data);
          storefileUploadResponse.push(fileUploadResponse.data);
        } catch (error) {
          console.log('Error uploading file:', error.response ? error.response.data : error.message);
        }
      }
      return { storefileUploadResponse, storeFileNameArray };
    } catch (error) {
      console.error('Save error:', error);
    }
  };

  const saveFilesToAttachment = async (payload) => {
    try {
      const response = await axios.post(`${checkGraph}/api/${serviceType}schcorrectiveattachments`, payload, config); if (response.status >= 200 && response.status <= 204) {
        setOpenDialog(true);
      }
      return response.data;
    } catch (error) {
      console.error('Save error:', error);
    };
  };

  const handleSaveClick = async (event) => {
    event.preventDefault();
    let hasError = false;

    rows.forEach((row) => {
      const rowId = row?.id;
      const value = dropDownValue[rowId];

      // If value is empty and documenttitle exists, trigger an error
      if ((!value || value === "") && row?.documenttitle) {
        hasError = true;

        // Set error state for this row
        setDropdownError((prev) => ({
          ...prev,
          [rowId]: true,
        }));

        setDropDownErrorMessage((prev) => ({
          ...prev,
          [rowId]: "This field is required",
        }));
      } else {
        // Clear error state for this row if it is valid
        setDropdownError((prev) => ({
          ...prev,
          [rowId]: false,
        }));

        setDropDownErrorMessage((prev) => ({
          ...prev,
          [rowId]: "",  // Clear error message
        }));
      }
    });

    // Stop submission if there are errors
    if (hasError) {
      return;
    };

    let checkFieldName = serviceType === "fem" ? "Fem" : "Bem";
    if (selectedFiles.length > 0) {
      try {
        const filteredSelectedFiles = selectedFiles.filter(file => rows.some(row => row.id === file.id));
        if (filteredSelectedFiles.length > 0) {
          const { storefileUploadResponse, storeFileNameArray } = await uploadFiles(filteredSelectedFiles);

          if (storefileUploadResponse?.length > 0) {
            let storefileUploadResponseFinal = [];

            for (let i = 0; i < storefileUploadResponse.length; i++) {
              const file = storefileUploadResponse[i];
              const selectedFileId = storeFileNameArray[i];

              const documentTitle = storeFileNameArray.find((item) => item.id === file.fileName)?.filename;
              const documenttype = documentTitle.split('.').pop().toLowerCase();
              if (documentTitle) {
                const rowId = selectedFileId?.selectedFileId || "";
                const attachementTypeValue = dropDownValue[rowId];

                const payload = {
                  filename: file?.fileName || "",
                  filesize: file?.fileSize || "",
                  filepath: "D:/IFAC-X/UploadFolder",
                  documenttitle: documentTitle || "",
                  [`${checkFieldName}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
                  createdby: createdBy || "",
                  documenttype: documenttype || "",
                  [`${checkFieldName}woattachmenttypeId`]: attachementTypeValue?.id || ""
                };

                try {
                  const response = await saveFilesToAttachment(payload);
                  if (response) {
                    storefileUploadResponseFinal.push(response);
                    fetchFiles();
                  } else {
                    console.log("Error saving file:", file.fileName);
                  }
                } catch (error) {
                  console.log('Error saving file:', error);
                }
              } else {
                console.log("Document Title not found for file:", file.fileName);
              }
            }
          } else {
            console.log("No files registered");
          }
        }
      } catch (error) {
        console.log('Error registering files:', error);
      }
    } else {
      console.log("No files selected for upload");
    };

  };  

  const handleCancelDialogClose = () => {
    setCancelDialogOpen(false);
  };

  const handleCancelDialogConfirm = () => {
    setCancelDialogOpen(false);
    navigate(-1, { replace: true });
  };

  const handleSnackbarClose = () => {
    setError(false);
  };

  const handleOnChange = (value, rowId) => {
    const rowIndex = rows?.findIndex(row => row?.id === rowId);

    if (rowIndex === -1) {
      return;
    };

    setDropDownValue(prev => ({
      ...prev,
      [rowId]: value,
    }));

    setDropdownError((prevErrors) => ({
      ...prevErrors,
      [rowId]: false,
    }));
    setDropDownErrorMessage((prevMessages) => ({
      ...prevMessages,
      [rowId]: '',
    }));

    const allowedImageTypes = ['jpeg', 'jpg', 'png'];

    // Check if the selected id is 1 or 2 and validate document type
    if ((value?.id === 1 || value?.id === 2) && rows[rowIndex]?.documenttype) {
      const documentType = rows[rowIndex]?.documenttype?.toLowerCase();

      if (!allowedImageTypes?.includes(documentType)) {
        setError(true);
        setErrorMessage("Error: Only JPEG, JPG, and PNG files are allowed for this selection.");
        setDropDownValue(prev => ({
          ...prev,
          [rowId]: { id: 3, label: "Others" },
        }));
      };
    };
  };

  
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (viewmode == true || mappedStatus === 6 || mappedStatus ===7) {
        setPage(pageName);
    } else {
        let hasError = false;
      // Check if rows length is greater than 1 and there are meaningful rows
      const gridRows = rows?.filter(row => row?.documenttitle || row?.file || row?.documenttype || row?.filesize);
      if (gridRows?.length < 1) {
          hasError = true;
          setAttachmentMandatory(true);
          return;
          }

    await handleSaveClick(event);
    if (processingPercentage === 100 && !viewmode) {
        setPage(pageName);
    } else if ((mappedStatus === 4 && processingPercentage > 50) || mappedStatus === 5 || mappedStatus === 8 ){
        setPage(pageName);
    } else {
      const statusId = basicDetails?.assessments?.repairType === "Outsource" ? statusList?.inProgressOutsource?.id : statusList?.inProgress?.id //To get the status ID
      await ScmRepositry.workorderStatusValue(serviceType, basicDetails?.id, statusId, processingPercentageValue?.workOrderAttachments);
        dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: processingPercentageValue?.workOrderAttachments }));
        setPage(pageName);
    }
    }
    
};

  // const columns = [
  //   {
  //     field: 'signature',
  //     headerName: 'Signature',
  //     minWidth: 200,
  //     minWidth: 150,
  //     cellRenderer: (params) => (
  //       <Button
  //         variant="outlined"
  //         component="label"
  //         size="small"
  //         sx={{
  //           width: '100px',
  //           height: '38px',
  //           padding: '4px 8px',
  //           fontSize: '0.75rem',
  //           display: 'flex',
  //           justifyContent: 'center',
  //         }}
  //         onClick={() => handleSignatureUpload(params.data.id)}
  //         disabled={((params?.data?.file?.type || params?.data?.fileType) ? true : false) || mappedStatus === 6}
  //       >
  //         {(params?.data?.file?.type || params?.data?.fileType) ? 'Uploaded' : 'Upload'}
  //       </Button>
  //     ),
  //   },
  //   { field: 'name', headerName: 'Name', width: 150, editable: true },
  //   { field: 'designation', headerName: 'Designation', width: 150, editable: true },
  //   { field: 'fileType', headerName: 'File Type', width: 150, editable: true },
  //   { field: 'size', headerName: 'Size', width: 130, editable: true },
  //   { field: 'date', headerName: 'Date', width: 130, editable: true,valueGetter: (params) => formatDate(params?.data?.date)},
  //   {
  //     field: 'actions',
  //     headerName: 'Actions',
  //     minWidth: 160,
  //     cellRenderer: (params) => (
  //       <>
  //         <CustomTooltip title="Delete">
  //           <Button onClick={handleSignatureDeleteClick(params?.data?.id)} disabled={viewmode || mappedStatus === 6 || ((signatureRows?.length === 1 && params?.data?.id && !params?.data?.fileType) ? true : false )}>
  //             <DeleteIcon />
  //           </Button>
  //         </CustomTooltip>
  //         {params?.data?.filename && (
  //            <CustomTooltip title="Download">
  //            <Button onClick={() => handleSignatureDownload(params?.data?.filename)} >
  //              <DownloadIcon />
  //            </Button>
  //          </CustomTooltip>
  //         )}
  //       </>
  //     ),
  //   }
  // ];

  return (
    <>
      <ComponentHeader
        mainHeader={findHeaderContent?.mainHeader}
        subHeader={findHeaderContent?.subHeader}
        secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
        statusType={"completed"}
      />
      <Box  >
        <form style={{ position: 'relative' }} onSubmit={handleSubmit}>
          <Stack direction={'row'} alignItems={'center'} gap={1.5}>
            <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.schcorrectiveno || ""}</Typography>
          </Stack>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            {!viewmode && mappedStatus !== 6 && <AddRowButton onClick={handleAddRow} />}
          </Grid>

{attachmentMandatory && (<Typography component={"span"} color={"error"}>
                                                        {"Please add at least one Attachment."}*
                                                    </Typography>)}
          <CustomAgGrid
            rows={rows}
            columns={[
              {
                field: 'attachmentType',
                headerName: 'Image Type',
                minWidth: 200,
                cellRenderer: (params) => {
                  const rowId = params?.data?.id || "";
                  const selectedOption = dropDownValue[rowId] || {id:3,label:"Others"};
                  const currentId = selectedOption?.id || params?.data?.attachmentType || "";
                  const currentOption = attachmentTypeOptions.find(option => option?.id === currentId);
                  const currentLabel = selectedOption?.label || currentOption?.label || '';
                  const OptionsValue = selectedOption?.id ? selectedOption : { id: currentId, label: currentLabel };
                  const disablefield = params?.data?.filename ? true : false;

                  return (
                    <div>
                      <CustomSelectInput
                        error={dropdownError[rowId]}
                        errorMessage={dropDownErrorMessage[rowId]}
                        name="isBefore"
                        value={OptionsValue || ""}
                        options={attachmentTypeOptions || []}
                        onChange={(value) => handleOnChange(value, rowId)}
                        disabled={disablefield || mappedStatus === 6}
                      />
                    </div>
                  );
                },
              },
              {
                field: 'file',
                headerName: 'File',
                flex: 1,
                cellRenderer: (params) => (
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    sx={{
                      width: '100px',
                      height: '38px',
                      padding: '4px 8px',
                      fontSize: '0.75rem',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    disabled={params.data?.documenttitle || mappedStatus === 6}
                  >
                    {params.data.documenttitle ? 'Uploaded' : 'Upload'}
                    <input
                      type="file"
                      hidden
                      onChange={(event) => handleFileChange(event, params?.data?.id)}
                    />
                  </Button>
                ),
              },
              {
                field: 'documenttitle',
                headerName: 'File Name',
                flex: 1,
              },
              {
                field: 'documenttype',
                headerName: 'File Type',
                flex: 1,
              },
              {
                field: 'filesize',
                headerName: 'Size',
                flex: 1,
              },
              {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                flex: 1,
                minWidth: 160,
                cellClassName: 'actions',
                cellRenderer: (params) => (
                  <>
                    <CustomTooltip title="Delete">
                      <Button onClick={handleDeleteClick(params?.data?.id)} disabled={viewmode || mappedStatus === 6 ||((rows?.length === 1 && params?.data?.id && !params?.data?.documenttitle) ? true : false)} >
                        <DeleteIcon />
                      </Button>
                    </CustomTooltip>
                    {params?.data?.filename && (
                      <CustomTooltip title="Download">
                      <Button onClick={(event) => handleDownloadClick(event, params?.data)} >
                        <DownloadIcon />
                      </Button>
                    </CustomTooltip>
                    )}
                  </>
                ),
              },
            ]}
            setGridApi={setGridApi}
            refSet={gridApi}
          />

          {/* <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
              <Grid >
                <Typography variant="title2" align="left">Add Signature</Typography>
                <Typography variant="body2" >
                  Please add files in format of doc, jpg, png, pdf.
                </Typography>
              </Grid>
              <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                {!viewmode && mappedStatus !== 6 && <AddRowButton onClick={handleSignatureAddRow} />}
              </Grid>
            </Stack>

            <CustomAgGrid
              rows={signatureRows}
              columns={columns}
              setGridApi={setGridApi}
            />

            <Dialog open={signatureDialog} onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                handleSignatureCloseDialog();
              }
            }} >
              <DialogContent>
                <ScmSignatureGrid
                  onCancel={handleSignatureCloseDialog}
                  onClear={handleSignatureCloseDialog}
                  onSave={(data) => handleSaveSignature(selectedRowId, data)}
                  rowData={signatureRows.find((row) => row.id === selectedRowId)}
                />
              </DialogContent>
            </Dialog>
          </Box> */}



          <Box>
            <ScmBottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} />
          </Box>

        </form>

      </Box>
      <CustomDialog
        open={error}
        onClose={handleSnackbarClose}
        content={errorMessage}
        confirmBtn="OK"
        onConfirm={() => setError(false)}
      />

      <CustomDialog
        open={cancelDialogOpen}
        onClose={handleCancelDialogClose}
        title="Unsaved Changes"
        content="Record(s) not Saved/Updated. Do you want to continue?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleCancelDialogConfirm}
        onCancel={handleCancelDialogClose}
      />
      <CustomDialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        title="Confirm Delete"
        content="Are you sure you want to delete?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteDialogClose}
      />

      {/* <CustomDialog
        open={signatureDeleteDialog}
        onClose={handleSignatureDeleteDialogClose}
        title="Confirm Delete"
        content="Are you sure you want to delete?"
        confirmBtn="Yes"
        cancelBtn="No"
        onConfirm={handleConfirmSignatureDeleteClick}
        onCancel={handleSignatureDeleteDialogClose}
      /> */}


    </>
  );
};

export default ScmAttachments;
